<div class="app-header header sticky">
  <div class="container-fluid main-container">
    <div class="d-flex align-items-center">
      <a aria-label="Hide Sidebar" class="app-sidebar__toggle" data-bs-toggle="sidebar" (click)="toggleSidebar()">
        <!-- <i class="fe fe-menu" aria-hidden="true"></i> -->
        <i class="humberger-menu" aria-hidden="true"></i>
      </a>
      <a class="header-brand1" routerLink="/dashboard">
        <img src="../assets/images/brand/ic_logo.svg" class="header-brand-img light-logo1">
      </a>
      <!-- sidebar-toggle-->
      <div class="header-search d-none d-lg-flex">
        <div class="form-inline">
          <div class="search-element"></div>
        </div>
      </div>
      <div class="d-flex order-lg-2 ms-auto header-right-icons header-search-icon">
        <div class="navbar navbar-collapse responsive-navbar p-0 ">
          <div class="collapse navbar-collapse" id="navbarSupportedContent-4" #collapse="ngbCollapse"
            [(ngbCollapse)]="isCollapsed" [horizontal]="true">
            <div class="d-flex">
              <!-- NOTIFICATIONS -->
              <div ngbDropdown class=" dropdown d-flex notifications">
                <a ngbDropdownToggle data-bs-toggle="dropdown" class="nav-link icon caret">
                  <!-- <i class="fe fe-bell "></i> -->
                   <img src="../../../../assets/images/ic_manage_notifications.svg">
                  <span [ngClass]="totalUnreadCount > 0 ? 'redDot' : ''"></span>
                </a>
                <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                  <div class="p-4">
                    <div class="d-flex">
                      <h5 class="border-bottom-0 mb-0 fs-16 font-weight-semibold"> Notifications <span
                          class="unreadCount">{{notificationCount || 0}}</span></h5>
                      <a class="ms-auto readAll" href="javascript:void(0);" (click)="markAllAsRead()">Mark all as read</a>
                    </div>
                  </div>
                  <div class="notificationslist">
                    <div class="tab-menu-heading">
                      <div class="tabs-menu1">
                        <ul class="nav">
                          <li class="nav-item">
                            <a class="nav-link" [ngClass]="selectedTab == 0 ? 'active' : ''" (click)="changeTab(0)">All</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" [ngClass]="selectedTab == 1 ? 'active' : ''" (click)="changeTab(1)">Orders</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" [ngClass]="selectedTab == 2 ? 'active' : ''" (click)="changeTab(2)">Inventory</a>
                          </li>
                          <li class="nav-item">
                            <a class="nav-link" [ngClass]="selectedTab == 3 ? 'active' : ''" (click)="changeTab(3)">Invoices</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                    <app-notification-listing [usedFor]="'header'" [notificationLists]="notificationLists"></app-notification-listing>
                  </div>
                  <div class="dropdown-divider"></div>
                  <a *ngIf="notificationLists?.length > 0" class="dropdown-item text-center pointer pt-3 pb-3 view--all"
                    routerLink="/notifications/view-all/{{selectedTab}}">View all notifications
                  </a>
                </div>
              </div>
              <!-- Profile -->
              <div ngbDropdown class="dropdown profile-1 d-flex ">
                <a ngbDropdownToggle href="javascript:void(0);" data-bs-toggle="dropdown"
                  class="nav-link icon leading-none d-flex">
                  <span class="iconBox">{{userDetails?.name | initials}}</span>
                  <span class="userName">{{userDetails?.name}}</span>
                </a>
                <div ngbDropdownMenu class="dropdown-menu dropdown-menu-end dropdown-menu-arrow">
                  <div class="p-5">
                    <div class="headBar d-flex">
                      <span class="iconBox">RL</span>
                      <div class="userInfo">
                        <div class="userName">{{userDetails?.name}}</div>
                        <div class="emailID">{{userDetails?.email}}</div>
                      </div>
                    </div>
                    <a ngbDropdownItem class="totalBusinesses pointer" (click)="openBusinessList()">Assigned
                      Businesses:
                      <strong>{{assignedBusinessesCount}}</strong></a>
                    <div class="dropdownLink d-flex">
                      <a (click)="changePassword()" class="pointer" ngbDropdownItem> Change password </a>
                      <a ngbDropdownItem (click)="onSignOut();">Sign out </a>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Horizontal SIDE-MENU -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>